import { motion } from "framer-motion";

export const PhoneMockup = ({ src, alt, testId, className = "", floatDelay = 0, eager = false }) => (
  <motion.div
    data-testid={testId}
    className={`relative ${className}`}
    animate={{ y: [0, -9, 0] }}
    transition={{ duration: 7.5, repeat: Infinity, ease: "easeInOut", delay: floatDelay }}
  >
    <div className="rounded-[2.7rem] bg-[#1A2230] p-[3px] shadow-[0_48px_90px_-28px_rgba(11,19,32,0.5)] ring-1 ring-white/25">
      <div className="relative aspect-[9/19.5] overflow-hidden rounded-[2.4rem] bg-black">
        <img
          src={src}
          alt={alt}
          loading={eager ? "eager" : "lazy"}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute left-1/2 top-2.5 h-[16px] w-[70px] -translate-x-1/2 rounded-full bg-black/95" />
      </div>
    </div>
  </motion.div>
);
